import { Reorder } from 'framer-motion';

import LeaderboardRow, { type LeaderboardRowColors } from './Leaderboard/LeaderboardRow';
import type { LeaderboardRowData, LeaderboardRowSize } from './Leaderboard/types';

interface LeaderboardItemProps {
  leaderboard: LeaderboardRowData[];
  colors?: LeaderboardRowColors;
  fontSize?: string;
  fontFamily?: string;
  size?: LeaderboardRowSize;
}

/**
 * Reorderable list of score bars. Expects a `Reorder.Group` ancestor — see
 * Leaderboard.tsx.
 */
const LeaderboardItem = ({
  leaderboard,
  colors,
  fontSize = '32px',
  fontFamily = 'Inter',
  size = 'full',
}: LeaderboardItemProps) => (
  <div className="w-full inline-flex flex-col justify-start items-start gap-4">
    {leaderboard.map((leader, index) => (
      <Reorder.Item
        as="div"
        key={leader.id || index}
        value={leader.id || index}
        className="w-full"
        layout
        transition={{ type: 'spring', stiffness: 40, damping: 20 }}
      >
        <LeaderboardRow
          leader={leader}
          index={index}
          colors={colors}
          fontFamily={fontFamily}
          fontSize={fontSize}
          size={size}
        />
      </Reorder.Item>
    ))}
  </div>
);

export default LeaderboardItem;
